export default {
  CONNECT_MAPPED_HTML: '@WS/CONNECT_MAPPED_HTML',
  COPY_ELEMENT: '@WS/COPY_ELEMENT',
  CUT_ELEMENT: '@WS/CUT_ELEMENT',
  BLUR_FOCUSED_ELEMENT: '@WS/BLUR_FOCUSED_ELEMENT',
  CHANGE_HTML: '@WS/VIEW/CHANGE_HTML',
  DELETE_ELEMENT: '@WS/DELETE_ELEMENT',
  DUPLICATE_ELEMENT: '@WS/DUPLICATE_ELEMENT',
  INSERT_BLOCK: '@WS/INSERT_BLOCK',
  INSERT_ELEMENT: '@WS/INSERT_ELEMENT',
  PASTE_ELEMENT: '@WS/PASTE_ELEMENT',
  REPLACE_ELEMENT: '@WS/REPLACE_ELEMENT',
  REMOVE_ELEMENT_ATTRIBUTE: '@WS/REMOVE_ELEMENT_ATTRIBUTE',
  SET_ELEMENT_ATTRIBUTE: '@WS/SET_ELEMENT_ATTRIBUTE',
  SET_INLINE_ELEMENT_STYLE: '@WS/SET_INLINE_ELEMENT_STYLE',
  SET_SELECTED_ELEMENT: '@WS/SET_SELECTED_ELEMENT',
  SET_FOCUSED_ELEMENT: '@WS/SET_FOCUSED_ELEMENT',
  SET_HOVERED_ELEMENT: '@WS/SET_HOVERED_ELEMENT',
  SET_SCROLL_POSITION: '@WS/SET_SCROLL_POSITION',
  SET_MOUSE_POSITION: '@WS/VIEW/SET_MOUSE_POSITION',
  SET_LOADED_STATUS: '@WS/VIEW/SET_LOADED_STATUS',
  SET_DISABLED_STATUS: '@WS/VIEW/SET_DISABLED_STATUS',
  SET_SCROLL_STATUS: '@WS/VIEW/SET_SCROLL_STATUS',
  SET_SELECTION: '@WS/VIEW/SET_SELECTION',
  SHIFT_ELEMENT: '@WS/SHIFT_ELEMENT',
  SYNCHRONIZE_ELEMENT: '@WS/SYNCHRONIZE_ELEMENT',
  SET_CHILDREN_PRESENCE: '@WS/SET_CHILDREN_PRESENCE',
  BULK_SET_CHILDREN_PRESENCE: '@WS/BULK_SET_CHILDREN_PRESENCE',
  BULK_VIEW_ACTIONS: '@WS/BULK_VIEW_ACTIONS',
  FORCE_RELOAD_VIEW: '@WS/FORCE_RELOAD_VIEW',
  UPDATE_ATOMIC_CSS: '@WS/UPDATE_ATOMIC_CSS',
  SET_DEVICE_MODE: '@WS/VIEW/SET_DEVICE_MODE',
};
